import { Subject } from 'rxjs';
import { ICampaigner } from './../../../../fundraiser/models/fundraiser.model';
import { DONATION_INFO_TEXT } from './../donation-info';
import { DOCUMENT } from '@angular/common';
import { EventsService } from './../../../../shared/services/events/events.service';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { UtilService } from './../../../../shared/services/util/util.service';
import { VariablesService } from './../../../../shared/services/variables/variables.service';
import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { VwoService } from '../../../../shared/services';

@Component({
  selector: 'app-donation-confirmation-sheet',
  templateUrl: './donation-confirmation-sheet.component.html',
  styleUrls: ['./donation-confirmation-sheet.component.scss']
})
export class DonationConfirmationSheetComponent implements OnInit {
  campaigner: ICampaigner;
  cancelPayment = new Subject();
  isStorypage = false;
  miniStory = false;

  constructor(
    public vars: VariablesService,
    public utilService: UtilService,
    private bottomSheetRef: MatBottomSheetRef<DonationConfirmationSheetComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private eventService: EventsService,
    @Inject(DOCUMENT) private document: Document,
    private dialog: MatDialog,
    private router: Router,
    public activatedRoute: ActivatedRoute,
    public vwo: VwoService
  ) { }

  info = DONATION_INFO_TEXT;
  beneficiaryName;
  isNGO = false;
  isMedical = false;

  ngOnInit(): void {
    this.campaigner = this.vars.fundraiser.campaigner;
    this.getBeneficiaryName();
    if (this.router.url.match('stories')) {
      this.isStorypage = true;
    }
    if (this.activatedRoute.snapshot.queryParams.mini_story) {
      this.miniStory = true;
    }
  }

  getBeneficiaryName() {
    if (this.vars.beneficiary) {
      this.beneficiaryName = this.vars.beneficiary.full_name;
    } else if (this.vars?.fundraiser?.beneficiaryname?.info_1) {
      this.beneficiaryName = this.vars?.fundraiser?.beneficiaryname?.info_1;
    } else if (this.vars?.fundraiser?.basicinfo) {
      this.beneficiaryName = this.vars.fundraiser.basicinfo.find(item => item.info_type === 'beneficiary_name')?.info_1;
    }
    this.isNGO = this.vars.fundraiser.parent_cause_id === 48;
    this.isMedical = this.vars.ALL_MEDICAL_CAUSES.includes(this.vars.fundraiser?.cause?.id) ? true : false;
  }

  handleCloseAndSendEvent(choice): void {
    const self = this;
    const choices = {
      cancel: () => {
        self.bottomSheetRef.dismiss();
        this.dialog.closeAll();
        this.cancelPayment.next(true);
        return 'cancel_popup';
      },
      closeBtn: () => {
        self.bottomSheetRef.dismiss();
        return 'close_btn_popup';
      },
      help: () => {
        self.bottomSheetRef.dismiss();
        return 'help_popup';
      }
    };

    const info1 = choices[choice]() || '';
    const payload = {
      eventName: 'donation_confirmation',
      event_type: 'campaign',
      page_name: this.vars.pageName || 'home',
      referrer_page: this.document.referrer,
      info_1: info1,
      info_2: ''
    };
    this.eventService.sendSystemEvent(payload).subscribe(_ => _);
  }
}
